(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'introSubjectReference', {
            bindings: {
                content:     '<'
            },
            templateUrl:    'app/views/partials/content/intro-subject-reference.html',
            controller:     IntroSubjectReferenceController,
            controllerAs:   'vm',

            renderingOptions: {
                'intro-major': {
                    inputs:    [ 'content="content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block', 'major- ' ]
                },
                'intro-subject-backlink': {
                    inputs:    [ 'content="content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    'intro-major': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'block' ],
                        classes:       null
                    },
                    'intro-subject-backlink': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'block' ],
                        classes:       null
                    }
                }
            }
        });



    /**
     * Renders headline and short non-formatted abstract text as an
     * introduction. If `referrerStudyArea` is present in (sub)qualification's
     * `metadata`, it construct a back-link to that subject area.
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SubpagesService} SubpagesService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function IntroSubjectReferenceController(
        $scope,
        LoggerFactory,
        ContentSwitchingService,
        SubpagesService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        var RESPONSE_VALUE_POSTGRAD_AREA = 'postgrad',
        RESPONSE_VALUE_SUBJECT_AREA      = 'undergrad',

        RESPONSE_ATTRIBUTE_REFERRER      = 'referrerStudyArea';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'IntroSubjectReferenceController', false );





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._      = TEXTS.SHARED.INTRO;

        $scope.Utils  = Utils;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            vm.isPostgradProfessionalSubpage = SubpagesService.isPostgradProfessionalSubpage();
        }





        /* ===== PRIVATE MEMBERS ============================================ */


        /** Uni-directional watchers */
        vm.$onChanges = function( changesObject ) {
            if ( changesObject.content && changesObject.content.currentValue ) {
                initQualsMetadata();
            }
        }


        function initQualsMetadata() {
            vm.qualification      = Utils.retrieveMetadataRecursively( $scope );
            vm.targetStateParams  = getQualsTargetStateParams();
        }


        /**
         * Constructs parameters required by `ui-sref` template
         * directive that might be used to dynamically construct URL to the
         * given subject area.
         *
         * @returns {{ id: string, queries: Object }}
         */
        function getQualsTargetStateParams() {
            if ( !vm.qualification || ( vm.qualification && !vm.qualification.hasOwnProperty( RESPONSE_ATTRIBUTE_REFERRER ) ) ) return null;


            var stateId = '.', stateQueries = {},
            referrerStudyArea = vm.qualification[ RESPONSE_ATTRIBUTE_REFERRER ];


            if ( referrerStudyArea.type == RESPONSE_VALUE_SUBJECT_AREA ){
                stateId = CONFIG.STATES.STUDY_AREA;
                stateQueries[ CONFIG.PARAMS.STUDY_AREA_ID ] = referrerStudyArea.id;
            } else if ( referrerStudyArea.type == RESPONSE_VALUE_POSTGRAD_AREA ){
                stateId = CONFIG.STATES.POSTGRAD_AREA;
                stateQueries[ CONFIG.PARAMS.POSTGRAD_AREA_ID ] = referrerStudyArea.id;
            } else {
                logger.error( "Cannot construct a back-link URL to the referring postgraduate subjects/subject areas `%s` due to unknown type `%s`", referrerStudyArea.name, referrerStudyArea.type );
                return null;
            }


            if ( stateId === CONFIG.STATES.STUDY_AREA && referrerStudyArea.hasOwnProperty( 'subjectId' ) && referrerStudyArea.subjectId ){
                stateQueries.subject = referrerStudyArea.subjectId;
            }

            // Add international and mode
            ContentSwitchingService.addGenericParamsToStateQuery( stateQueries );

            return {
                id:         stateId,
                queries:    stateQueries
            }
        }
    }



    IntroSubjectReferenceController.$inject = [ '$scope', 'LoggerFactory', 'ContentSwitchingService', 'SubpagesService', 'Utils', 'TEXTS', 'CONFIG' ];
})();
